import React from 'react';
import { Link } from 'react-router-dom';
import { Logo, useSectionLink } from './MarketingNav';
import Claws from '../motion/Claws';

export default function MarketingFooter() {
  const sectionLink = useSectionLink();
  const year = new Date().getFullYear();
  return (
    <footer className="pnp-footer">
      <div aria-hidden="true" className="pnp-footer-glow" />
      <Claws thin grow={false} className="pnp-footer-claws" style={{ right: '11%', top: -40, height: '140%', opacity: 0.25, position: 'absolute', zIndex: -1 }} />
      <div className="pnp-wrap">
        <div className="pnp-footer-top">
          <div className="pnp-footer-brand">
            <Logo />
            <p>
              Free UFC pick&apos;em pools for you and your crew. Private group entertainment only: no wagers, no
              payments. Not affiliated with the UFC.
            </p>
            <div className="pnp-footer-social">
              <a href="https://x.com/picknpraymma" target="_blank" rel="noopener noreferrer" aria-label="Pick 'N Pray on X">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
              </a>
              <a href="https://www.instagram.com/picknpray_mma/" target="_blank" rel="noopener noreferrer" aria-label="Pick 'N Pray on Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" /></svg>
              </a>
            </div>
          </div>
          <div className="pnp-footer-cols">
            <nav className="pnp-footer-col" aria-label="Product">
              <h4>Play</h4>
              <a href="/#how" onClick={sectionLink('how')}>How it works</a>
              <a href="/#pools" onClick={sectionLink('pools')}>Pools</a>
              <a href="/#demo" onClick={sectionLink('demo')}>Try it now</a>
              <Link to="/join/TITLESHOT">Title Shot pool</Link>
            </nav>
            <nav className="pnp-footer-col" aria-label="Account">
              <h4>Account</h4>
              <Link to="/register">Join free</Link>
              <Link to="/login">Sign in</Link>
              <Link to="/register?redirect=/create-pool">Start a pool</Link>
              <Link to="/join">Join with a code</Link>
            </nav>
            <nav className="pnp-footer-col" aria-label="Help">
              <h4>Help</h4>
              <Link to="/faq">FAQ</Link>
              <Link to="/terms">Terms</Link>
              <Link to="/privacy">Privacy</Link>
              <a href="mailto:kyle@picknpray.com">kyle@picknpray.com</a>
            </nav>
          </div>
        </div>
        <div className="pnp-footer-bottom">
          <span>© {year} Pick &apos;N Pray · picknpray.com</span>
          <span>For entertainment only. Not affiliated with, endorsed or sponsored by the UFC.</span>
        </div>
      </div>
      <div className="pnp-footer-word" aria-hidden="true">Pick <b>&apos;N</b> Pray</div>
    </footer>
  );
}
